import React from 'react'
import styles from "./tnpsc-group-iv-test-series.module.css";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';
import Head from 'next/head';

const Tnpsc_gr_IV_testbatch = () => {
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="noindex,nofollow" />
            <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group 4 Test Series | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group 4 Test Batch | Shankar IAS Academy" />
            <meta name="description" content="Shankar IAS Academy's TNPSC Group 4 Test Series: Elevate your preparation with expert coaching and proven strategies. Get success in Group 4 exams!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-iv-test-series/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group 4 Test Batch | Shankar IAS Academy" />
            <meta property="og:description" content="Shankar IAS Academy's TNPSC Group 4 Test Series: Elevate your preparation with expert coaching and proven strategies. Get success in Group 4 exams!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-iv-test-series/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="tnpsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>TNPSC Gr-<b>Ⅳ</b> Test Series 2024 - Shankar IAS Academy</h1>
                </div>
            </div>


            <div className="container">
                <div className='py-2' style={{backgroundColor: "#001e62"}}>
                <h2 className={`${styles.tabletitle}`}>TNPSC Group IV Test Series 2024</h2>
                </div>
                <div className={`${styles.tablescroll} prelimstable`}>
                    <table className="table d-none d-lg-block">
                        <thead className={`${styles.table1}`} >
                            <tr>
                                <td className={`${styles.tableheading}`}>Center<br /></td>
                                <td className={`${styles.tableheading}`}>Batch<br /></td>
                                <td className={`${styles.tableheading}`}>Starts On<br /></td>
                                <td className={`${styles.tableheading}`}>Offline Fee<br /></td>
								  <td className={`${styles.tableheading}`}>OnlineFee<br /></td>
                                <td className={`${styles.tableheading}`}>English Schedule<br /></td>
                                
                                <td className={`${styles.tableheading}`}>Payment<br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Chennai - Anna Nagar<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Online/Offline)</td>
                                <td className={`${styles.tablepara}`}>18th March 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹1750 (For new students)<br />₹1500 (For Old students)</td>
								 <td className={`${styles.tablepara}`}>₹1750 (For both <br /> new students  and old students)</td>
                                <td><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear Up 4 Schedule Batch1-Annanagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                              
                                
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Trichy<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Offline)</td>
                                <td className={`${styles.tablepara}`}>21st March 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹1750 (For new students)<br />₹1500 (For Old students)</td>
								 <td className={`${styles.tablepara}`}>--</td>
                                <td><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear%20Up-Schedule-Trichyy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                              
                                
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Thiruvarur<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Online/Offline)</td>
                                <td className={`${styles.tablepara}`}>20th March 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹1750 (For new students)<br />₹1500 (For Old students)</td>
								 <td className={`${styles.tablepara}`}>₹1750 (For both <br />new students and old students)</td>
                                <td><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear%20Up-Schedule%20-%20Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                              
                                
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Madurai<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Offline)</td>
                                <td className={`${styles.tablepara}`}>24th March 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹1750 (For new students)<br />₹1500 (For Old students)</td>
								 <td className={`${styles.tablepara}`}>--</td>
                                <td><Link href="/pdf/TNPSC-group-iv-test-series-2024/GEAR%20-%20UP%20TEST%20SERIES%20-%20Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                              
                                
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Salem<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Offline)</td>
                                <td className={`${styles.tablepara}`}>24th March 2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹1750 (For new students)<br />₹1500 (For Old students)</td>
								 <td className={`${styles.tablepara}`}>--</td>
                                <td><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gr-IV%20Gear%20UP-Salem-%202024.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                              
                                
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            <tr className="pt-2">
                                <td className={`${styles.tablepara} border-0`}>Namakkal<br /></td>
                                <td className={`${styles.tablepara}`}>Batch IV Regular(Offline)</td>
                                <td className={`${styles.tablepara}`}>05th  April  2024<br /></td>
                                <td className={`${styles.tablepara}`}>₹1750 (For new students)<br />₹1500 (For Old students)</td>
								 <td className={`${styles.tablepara}`}>--</td>
                                <td><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear%20Up%204%20-%20Namakkal-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></td>
                              
                                
                                <td className="border-0"><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>

                            
                            
                        </tbody>
                    </table>
                </div>

                {/* mobile view table*/}
          <div className="container d-lg-none">
                            <div className="pt-2">
                            <p className={`${styles.mbtableheading} pt-2`}>Chennai - Anna Nagar<br/></p>
                                <p className={`${styles.tablepara}`}>Batch IV Regular(Online/Offline)<br/>18th March 2024<br />₹1750 (For new students)<br />₹1500 (For Old students)<br />₹1750 (For both new students and old students)</p>
								
                                <div><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear Up 4 Schedule Batch1-Annanagar.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                             
                                <hr/>

                            </div>
                            <div className="pt-2">
                            <p className={`${styles.mbtableheading} pt-2`}>Trichy<br/></p>
                                <p className={`${styles.tablepara}`}>Batch IV Regular(Offline)<br/>21st March 2024<br />₹1750 (For new students)<br />₹1500 (For Old students)<br /></p>
								
                                <div><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear%20Up-Schedule-Trichyy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                             
                                <hr/>

                            </div>
                            <div className="pt-2">
                            <p className={`${styles.mbtableheading} pt-2`}>Thiruvarur<br/></p>
                                <p className={`${styles.tablepara}`}>Batch IV Regular(Online/Offline)<br/>20th March 2024<br />₹1750 (For new students)<br />₹1500 (For Old students)<br />₹1750 (For both new students and old students)</p>
								
                                <div><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear%20Up-Schedule%20-%20Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                             
                                <hr/>

                            </div>
                            <div className="pt-2">
                            <p className={`${styles.mbtableheading} pt-2`}>Madurai<br/></p>
                                <p className={`${styles.tablepara}`}>Batch IV Regular(Offline)<br/>24th March 2024<br />₹1750 (For new students)<br />₹1500 (For Old students)<br /></p>
								
                                <div><Link href="/pdf/TNPSC-group-iv-test-series-2024/GEAR%20-%20UP%20TEST%20SERIES%20-%20Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                             
                                <hr/>

                            </div>

                            <div className="pt-2">
                            <p className={`${styles.mbtableheading} pt-2`}>Salem<br/></p>
                                <p className={`${styles.tablepara}`}>Batch IV Regular(Offline)<br/>24th March 2024<br />₹1750 (For new students)<br />₹1500 (For Old students)<br /></p>
								
                                <div><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gr-IV%20Gear%20UP-Salem-%202024.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                             
                                <hr/>

                            </div>

                            <div className="pt-2">
                            <p className={`${styles.mbtableheading} pt-2`}>Namakkal<br/></p>
                                <p className={`${styles.tablepara}`}>Batch IV Regular(Offline)<br/>05th April 2024<br />₹1750 (For new students)<br />₹1500 (For Old students)<br /></p>
								
                                <div><Link href="/pdf/TNPSC-group-iv-test-series-2024/Gear%20Up%204%20-%20Namakkal-2024.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link></div>
                                <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                             
                                <hr/>

                            </div>

            </div>  
            </div>

            <Footer />
        </>
    )
}

export default Tnpsc_gr_IV_testbatch;